import { useTranslation } from 'react-i18next';
import { ArticleForm } from '@pages/admin/article/article-form/ArticleForm';



export const NewArticle = () => {
	const { t } = useTranslation('admin');

	return (
		<div className="app-page admin-page article-page">
			
			<h1>{t('pages.article.headerNew')}</h1>

			<ArticleForm />

		</div>
	)
}